/**
 * Global Redux State Objects
 * Contains global loading state
 */

import { 
  SET_AUTH_ERROR,
  CLEAR_AUTH_ERROR,
  UPDATE_SMART_LOADER
} from "../../actions/app/constants";

const defaultState = {
  isLoading: [],
  smartLoader: {
    loading: false,
    steps: []
  },
  isAuthError: false
};

export const global = (state = defaultState, action) => {
  switch (action.type) {
    case SET_AUTH_ERROR:
      return {
        ...state,
        isAuthError: true,
        isLoading: []
      };
    case CLEAR_AUTH_ERROR:
      return {
        ...state,
        isAuthError: false
      };
    case UPDATE_SMART_LOADER:
      return {
        ...state,
        smartLoader: action.loader
      };
    default:
      return state;
  }
};
